import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var OnboardingChecklistItem = require("components/users/teachers/onboarding/OnboardingChecklistItem");
var OnboardingProgressDisplay = require("components/users/teachers/onboarding/OnboardingProgressDisplay");
var TeacherOnboarding = require("lib/account/TeacherOnboarding");
var WhooosReadingServices = require('lib/web/WhooosReadingServices');

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
import moment from "moment";
import _ from "underscore";

require("users/teachers/onboarding_checklist.scss");

@connect(
	(state,props)=>{
		return {admin: RosterSelectors.admin({state, id: CurrentUser.get().id})}
	},
	(dispatch, props) => {
		function populateData(){
			dispatch(RosterActions.fetchAdmins({filters:{ids: [CurrentUser.get().id]},
				embeds: ['user.prefs,admin.org_ids,admin.survey_prompts']}))
		}
		function updateAdmin(updateData){
			dispatch(RosterActions.updateAdmin({id: CurrentUser.get().id, update: updateData}))
		}
		return {
			populateData: populateData,
			updateAdmin: updateAdmin
		}
	}
)
@providePopulateData()
class OnboardingChecklist extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	isOnboardingComplete() {
		if (!this.props.admin){return true}
		else{
			var onboardingData = this.props.admin.prefs.onboarding;
			return _.select(onboardingData, (stepData, key) => {
				return !stepData;
			}).length == 0;	
		}
	}

	hideChecklist() {
		return !CurrentUser.isTeacherAdmin() || !this.props.admin || !this.props.admin.prefs;
	}
	completeOnboarding(){
		window.wrNotifications.triggerDropDownNotification({
			title: "Now you are ready!", text: "Your students are in great hands.", icon: "ok-circle" });
	}
	triggerViewData() {
		this.trigger("view-data")
	}
	triggerCustomizeAssignments() {
		this.trigger("customize-assignments")	
	}
	triggerSelectSchool(){
		this.trigger("select-school")
	}
	triggerSelectStandards(){
		this.trigger('select-standards')
	}
	triggerAddStudents(){
		this.trigger('add-students')
	}
	triggerAutograderDemo() {
		this.trigger('autograder-demo')
	}
	trigger(step) {
		var onboarding = {}
		for (var key in this.props.admin.prefs.onboarding){
			onboarding[key] = this.props.admin.prefs.onboarding[key]
		}

		if (!onboarding[step]) {
			onboarding[step] = true
			this.updateUserOnboarding(onboarding)
			
			//Check to see if the checklist is finished
			for(var key in onboarding){
				if(!onboarding[key]){ 
				  var moreItemsLeft = true
				}
			}
			//if no more items, display the banner.
			if(!moreItemsLeft){
				this.completeOnboarding()
			}
		}
		
	}
	skipIntroduction() {
		var r = confirm("Skipping this introduction will permanently remove the tutorial steps from your account. Are you sure you want to skip the introduction?");
		if (r == true) {
			LuckyOrangeClient.tagComponent("skipChecklist");
			var onboarding = _.clone(this.props.admin.prefs.onboarding);
			_.each(onboarding, (value, step) => {
				onboarding[step] = true
			})
			this.updateUserOnboarding(onboarding)
		}
	} 
	simpleSkipIntroduction() {
		var onboarding = _.clone(this.props.admin.prefs.onboarding);
		_.each(onboarding, (value, step) => {
			onboarding[step] = true
		})
		this.updateUserOnboarding(onboarding)
		Mycroft.buildEventHandler({
			category: "Paywall", action: "start-silver-trial", label: this.props.featureType + "-paywall" });
	}
	updateUserOnboarding(onboarding) {
		var new_data = {}
		new_data.prefs = {...this.props.admin.prefs, onboarding: onboarding}
		this.props.updateAdmin(new_data)
	}
	render() {
		if (this.hideChecklist()) {
			return (
				<div className="emptyOnboardingChecklist" />
			);
		}

		var onboardingData = this.props.admin ? this.props.admin.prefs.onboarding : CurrentUser.get().prefs.onboarding;


		// if there are no incomplete steps, don't display the checklist
		// TODO: show success state and allow user to dismiss

		// CurrentUser.get().account.override_data.onboarding_trial
		if (this.isOnboardingComplete()) {
			return null;
		}

		var orderedKeys = TeacherOnboarding.getOrderedKeys();
		var completions = _.map(orderedKeys, (itemKey, k) => {
			return _.find(onboardingData, (stepData, key) => {
				return key == itemKey;
			});
		})
		// this.props.completed_quiz
		var quizzesCompleted = CurrentUser.get().completed_quiz_count >= 100;
		var nextIndex = completions.indexOf(false)
		var lasCompleteIndex = -1
		var checklistItems = _.map(orderedKeys, (itemKey, k) => {
			var isComplete = completions[k]
			var isNext = k == nextIndex
			if (itemKey == "complete-quizzes") {
				return <OnboardingChecklistItem itemKey={ itemKey } isComplete={ quizzesCompleted } hideActionLink={ true }
							isNext={ isNext } key={ itemKey } />
			} else {
				return <OnboardingChecklistItem itemKey={ itemKey } isComplete={ isComplete } 
							isNext={ isNext } key={ itemKey } />
			}
		});

		var completionsNoQuizzes = _.reject(completions, function(completion) { return completion == undefined })
		completionsNoQuizzes.push(quizzesCompleted)
		var currentComplete= _.select(completionsNoQuizzes, function(completion){ return completion == true }).length;
		
		var helpLink = (<a href="https://www.whooosreading.org/help" target="_blank">Visit Help Center</a>)
		var divider = <div className="verticalDivider" />
		// var percentage = parseInt(_.select(completions).length / parseFloat(completions.length) * 10) * 10
		// var completionStatus = (
		// 	<div className="completionStatus">
		// 		<div className="display">
		// 			<span className="percentage">
		// 				{ percentage }%
		// 			</span>
		// 		</div>
		// 	</div>
		// )

		return (
			<div className="onboardingChecklist">
				<div className="itemContainer">
					<div>
						{ checklistItems }
					</div>
				</div>
				<div className="text-center">
					{ helpLink }
					{ divider }
					<a className="skipLink" onClick={this.skipIntroduction.bind(this)}>Skip Introduction</a>
				</div>

			</div>
		);
	}
	componentDidMount() {
		$(window.document).on("onboarding-trigger-view-data", this.triggerViewData.bind(this));
		$(window.document).on("onboarding-trigger-customize-assignments", this.triggerCustomizeAssignments.bind(this));
		$(window.document).on("onboarding-trigger-select-school", this.triggerSelectSchool.bind(this));
		$(window.document).on("onboarding-trigger-select-standards", this.triggerSelectStandards.bind(this))
		$(window.document).on("onboarding-trigger-add-students", this.triggerAddStudents.bind(this));
		if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) { 
			$(window.document).on("onboarding-trigger-autograder-demo", this.triggerAutograderDemo.bind(this));
		}
	}

	componentWillUnmount() {
		$(window.document).off("onboarding-trigger-view-data");
		$(window.document).off("onboarding-trigger-customize-assignments");
		$(window.document).off("onboarding-trigger-select-school");
		$(window.document).off("onboarding-trigger-select-standards")
		$(window.document).off("onboarding-trigger-add-students");
		if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) {
			$(window.document).off("onboarding-trigger-autograder-demo");
		}
	}
}

OnboardingChecklist.propTypes = StrictPropTypes({
	completed_quiz_count: PropTypes.number
});

module.exports = OnboardingChecklist;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingChecklist.js